import {
  checkSlidersCorrect,
  resetUpdatedKeyInDNDQ,
  VISIBILITY,
} from '@learningblocks/protocol-constants/lib/Utilities';
const NEXT_COMPONENT = 'nextComponent';

export function submitDNDQAnswer(state, payload) {
  return {
    ...state,
    currentSection: updateSubmitInCurrentSection(state.currentSection, payload),
  };
}

function updateSubmitInCurrentSection(currentSection, payload) {
  return {
    ...currentSection,
    components: updateSubmitInComponents(currentSection.components, payload),
  };
}

function updateSubmitInComponents(components, payload) {
  const {newcomponents} = components.reduce(
    (acc, component) => {
      // updating submitted component
      if (component.id === payload.componentID) {
        component = updateSubmitInDNDQComponent(component);
        if (component.hasOwnProperty(NEXT_COMPONENT)) {
          acc.forward = {
            complete: component.complete,
            nextComponent: component.nextComponent,
          };
        }
      }

      // updating forward component and setting its visibility
      if (
        acc.forward &&
        acc.forward.complete &&
        acc.forward.nextComponent === component.id
      ) {
        component = {...component, visibility: VISIBILITY.VISIBLE};
        acc.forward = null;
      }
      acc.newcomponents = [...acc.newcomponents, component];
      return acc;
    },
    {
      newcomponents: [],
      forward: null,
    }
  );
  return newcomponents;
}

function updateSubmitInDNDQComponent(component) {
  if (component.totalAttempts === -10 || component.totalAttempts > 0) {
    const complete = checkSlidersCorrect(component.sliders);
    let sliders = resetUpdatedKeyInDNDQ(component.sliders);
    if (complete) {
      sliders = sliders.map(disableSlider);
    }
    const totalAttempts =
      component.totalAttempts === -10 ? -10 : component.totalAttempts - 1;
    return {
      ...component,
      complete,
      sliders,
      totalAttempts,
      showFeedback: true,
    };
  } else {
    return {
      ...component,
      complete: true,
      showFeedback: true,
      totalAttempts: 0,
    };
  }
}

function disableSlider(slider) {
  return {...slider, disable: true};
}
